<template>
<div>
    <MbReportTabs selected="contents" :userId="userId"></MbReportTabs>

    <div class="row">
        <div class="col-lg-10 mx-auto my-4 my-lg-1">
            <MbLoading v-if="loading" />
            <div v-else-if="!contents || contents.length == 0" class="py-5 text-center">
                <p>Nessuna attività da visualizzare.</p>
            </div>
            <div v-else class="py-5">
                <div
                    v-for="(content, rk) in contents" :key="rk"
                    class="erk-row-hover row mb-2 mx-3 p-2 ">
                    <!-- Colonna sinistra - immagine -->
                    <div class="col-3 col-lg-2 px-0">
                        <img :src="content.thumbnail" class="img-fluid" alt="">
                    </div>
                    <!-- /Colonna sinistra - immagine -->

                    <!-- Colonna destra - dati -->
                    <div class="col-9 col-lg-10">
                        <div class="row h-100">
                            <div class="col-12">
                                <div class="row align-items-start">
                                    <div class="col-12">
                                        <h5 class="mb-1">{{content.name}}</h5>
                                        <span class="d-block"><em><small>{{content.authors}}</small></em></span>
                                        <p class="mt-1 mb-1"><strong>{{content.goal}}</strong></p>
                                        <div class="badge color-materia text-decoration-none ps-0 mb-1">{{ content.attivita }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 pe-0 mt-4">
                                <div class="row h-100 align-items-end">
                                    <div class="col-12">
                                        <span class="text-primary d-inline-block fw-bolder me-4">
                                            <i class="bi bi-window-fullscreen me-2"></i> {{ content.question_num }}/{{ content.question_total }}
                                        </span>
                                        <span class="text-primary d-inline-block fw-bolder me-4"><i class="bi bi-clock me-2"></i>{{ formatNumber( content.time / 1000 ) }} s</span>
                                        <span class="text-primary d-inline-block fw-bolder me-4"><i class="bi bi-trophy me-2"></i>{{ formatNumber(content.score * 100, 0 ) }} %</span>

                                        <div class="text-end">
                                            <a :href="content.url" class="btn btn-secondary">
                                                <span class="bi bi-bar-chart"></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /Colonna destra - dati -->
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>

import MbLoading from '@/components/ui/base/MbLoading'
import axios from 'axios'
import MbReportTabs from './MbReportTabs.vue'

export default{
    components: {
        MbLoading,
        MbReportTabs
    },
    props: {
        userId: [Number, String]
    },
    data(){
        return {
            loading: true,
            contents: []
        }
    },
    mounted(){
        this.load()
    },
    methods: {
        load(){
            this.isLoading = true
            axios.get('/structure/student/report/ReportContentsAction-findContents?userId' + this.userId, {
                params: {
                    userId: this.userId
                }
            }).then(response => {
                this.contents = response.data
                this.loading = false
            }).catch(error => {
                console.error(error)
                this.loading = false
            })
        },
        //format number with two digits
        formatNumber(number, digits = 2){
            return number.toFixed(digits).replace('.', ',')
        }
    }

}
</script>